export default __webpack_public_path__ + "static/media/Armwraps of the Doomsayer.3b289c4a.jpg";